import {
  GetCatalogSectionsOfflineOutput,
  GetCatalogSectionsOutput,
} from '../types/catalogs.repository.types';

export const isGetCatalogSectionsOfflineOutput = (
  output: GetCatalogSectionsOutput,
): output is GetCatalogSectionsOfflineOutput => {
  return !!(output as GetCatalogSectionsOfflineOutput).offlineSectionProductSet;
};
